// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"_2cFcumG","h5Text":"_3fhyYCP","h4Text":"rcB-Vfb","h3Text":"_1N5XO_v","srOnly":"J_TLBNe","link":"_35pvhsT _2cFcumG","title":"pQxhHu0 _1N5XO_v","listContainer":"_2vx2JAg"};